<header class="brd-header">
  <div class="brd-header-menu">
    <a [routerLink]="['/']">
      <img src="assets/images/boardLogo.png" />
    </a>
  </div>
  <div class="brd-header-nav">
    <div *ngFor="let item of navItems" class="brd-nav-item">
      <a [routerLink]="[item.link]" [ngClass]="{ selected: routerService.url === item.link }">{{ item.text }}</a>
    </div>
  </div>
  <div class="brd-header-user">
    <dx-menu
      [showFirstSubmenuMode]="showFirstSubmenuModes"
      orientation="horizontal"
      cssClass="user-menu-item"
      submenuDirection="auto"
      [hideSubmenuOnMouseLeave]="true"
      (onSubmenuShowing)="userMenuVisible = true"
      (onSubmenuHiding)="userMenuVisible = false"
    >
      <dxi-item template="notifyBell"> </dxi-item>
      <dxi-item template="userIcon">
        <dxi-item *ngIf="viewButtonSuperUser">
          <a *dxTemplate (click)="newsMenuVisible.set(false); routerService.navigate(['/admin-portal'])" class="submenu-item">
            <mat-icon svgIcon="superuser-16"></mat-icon>
            <div>Superuser View</div>
          </a>
        </dxi-item>
        <dxi-item *ngIf="viewButtonSuperUser" [disabled]="true">
          <div *dxTemplate class="submenu-divider"></div>
        </dxi-item>
        <dxi-item *ngIf="viewButtonSuperUser && maintenance$ | async as maintenance">
          <div (click)="openMaintenancePopup(maintenance)" *dxTemplate class="submenu-item">
            <mat-icon>build</mat-icon>
            <div *ngIf="maintenance.id; else noMaintenance">
              Schedule: <strong>{{ maintenanceScheduleDate() | date: "MM-dd-yyyy 'h' HH:mm" }}</strong>
            </div>
            <ng-template #noMaintenance>
              <div matTooltip="Schedule maintenance">New Maintenance</div>
            </ng-template>
          </div>
        </dxi-item>
        <dxi-item *ngIf="viewButtonSuperUser" [disabled]="true">
          <div *dxTemplate class="submenu-divider"></div>
        </dxi-item>
        <dxi-item [disabled]="true" *ngIf="team$ | async as team">
          <div *dxTemplate class="team-container">
            <div class="team-title">Team:</div>
            <div class="team-value">{{ teamName() }}</div>
            <div class="team-title">Active users last 30 days:</div>
            <dx-text-box
              class="team-member-search"
              stylingMode="outlined"
              placeholder="Search"
              valueChangeEvent="input"
              (onValueChanged)="onSearchChange($event)"
            >
              <dxi-button name="search" location="before" [options]="searchButtonOptions"></dxi-button>
            </dx-text-box>
            <dx-scroll-view class="team-member-scroll" height="100%" *ngIf="team.length; else teamEmpty">
              <div *ngFor="let user of team" class="team-member">
                <div class="team-icon">
                  {{ user.iconText }}
                </div>
                <div class="team-member-detail">
                  <div class="team-member-name">{{ user.name }}</div>
                  <div class="team-member-username">{{ user.userName }}</div>
                </div>
              </div>
            </dx-scroll-view>
            <ng-template #teamEmpty>
              <div class="team-empty">No team members</div>
            </ng-template>
          </div>
        </dxi-item>
        <dxi-item [disabled]="true">
          <div *dxTemplate class="submenu-divider"></div>
        </dxi-item>
        <dxi-item>
          <div *dxTemplate class="submenu-item" (click)="signOut()">
            <mat-icon svgIcon="trash-16"></mat-icon>
            <div>Sign out</div>
          </div>
        </dxi-item>
      </dxi-item>
      <div *dxTemplate="let item of 'userIcon'" class="user-image">
        <brd-user-image [showStatus]="false"></brd-user-image>
        <mat-icon svgIcon="arrow-expander-down-16"></mat-icon>
      </div>
      <div *dxTemplate="let item of 'notifyBell'" class="notify-bell">
        <mat-icon svgIcon="notify-bell-24" (click)="newsMenuVisible.set(!newsMenuVisible())"></mat-icon>
        <ng-container *ngIf="badgeObs | async as badge">
          <div *ngIf="badge.length" class="badge" (click)="newsMenuVisible.set(!newsMenuVisible())">{{ badge.length }}</div>
          <div *ngIf="badge.length && newsMenuVisible() && !userMenuVisible" class="news-container">
            <div *ngIf="badge.length > 1" class="news-container-title">
              There are <strong>{{ badge.length }}</strong> updates:
            </div>
            <dx-scroll-view [ngClass]="{ expanded: expanded }" [disabled]="!expanded">
              <div *ngFor="let news of badge; index as i" class="news-item-container">
                <div class="news-item" (click)="openNewsPopup(news, i)">
                  <div class="news-item-category">
                    <div class="category" [style]="{ background: news.categoryColor }"></div>
                  </div>
                  <div class="news-item-title">{{ news.title }}</div>
                  <div class="news-item-text">
                    <strong style="margin-right: 8px">{{ news.lastUpdate | date: "MM/dd/yyyy" }}</strong
                    >{{ news.text }}
                  </div>
                  <div class="news-item-action">READ MORE ></div>
                </div>
              </div>
            </dx-scroll-view>
            <div class="news-action">
              <brd-button text="SEE ALL NEWS" (click)="seeAllNews($event)"></brd-button>
              <brd-button
                *ngIf="badge.length > 1"
                [text]="expanded ? 'SHOW LESS' : 'SHOW MORE'"
                color="no-border"
                (click)="expanded = !expanded"
              ></brd-button>
            </div>
          </div>
        </ng-container>
      </div>
    </dx-menu>
  </div>
</header>
